<template>
   <div class="authentication">
       <headerTab :tabList="tabList"></headerTab>
       <div class="authentication_box">
           <el-form class="authentication_box_form" label-width="100px">
               <el-form-item label="姓名：">
                    <el-input v-model="form.name" placeholder="请输入您的真实姓名"></el-input>
                </el-form-item>
                 <el-form-item label="联系方式：">
                    <el-input v-model="form.name" placeholder="请输入您的本人手机号"></el-input>
                </el-form-item>
                <el-form-item label="验证码：">
                    <el-input v-model="form.name" style="width:184px" placeholder="请输入验证码"></el-input>
                    <el-button type="primary" class="authentication_box_from_code" style="width:106px">获取验证码</el-button>
                </el-form-item>
                 <el-form-item label="公司名称：">
                    <el-input v-model="form.name" placeholder="请输入公司名称"></el-input>
                </el-form-item>
                <el-form-item label="营业执照：">
                    <!-- <div class="authentication_box_form_explain">
                        <img src="../../assets/authentication/authentication_msg.png" alt="">
                        <span>认证指引</span>
                    </div> -->
                    <div class="authentication_box_form_card">
                        <img src="../../assets/authentication/authentication_bg1.png" alt="">
                        <img style="margin-left:20px" src="../../assets/authentication/authentication_bg1.png" alt="">
                    </div>
                </el-form-item>
                <el-form-item class="authentication_box_from_item">
                    <el-button class="" type="primary">保存</el-button>
                </el-form-item>

           </el-form>
       </div>
   </div>
</template>

<script>
import headerTab from '../../components/header_tab'
export default {
   data (){
       return {
           tabList:[
               {name:'同行认证',id:1}
           ],
           form:{}
       }
   },
   components: {
       headerTab
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       
   },
   created() {
       
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.authentication{
    padding:0 20px ;
    &_box{
        margin-top:20px;
        &_title{
            font-size: 20px;
            font-weight: 500;
            color:#333;
            padding: 20px 0;
        }
        &_form{
            width:400px;
            &_explain{
                display: flex;
                align-items: center;
                justify-content:flex-end;
                img{
                    width:20px;
                    height: 20px;
                }
                span{
                    font-size: 14px;
                    color:#999999;
                }
            }
            &_card{
                display: flex;
                justify-content:space-between;
                img{
                    width:154px;
                    height: 112px;
                    cursor: pointer;
                }
                
            }
            /deep/ .authentication_box_from_code.el-button{
                height: 36px;
                padding: 10px 16px;
                margin-left: 5px;
            }
            /deep/ .el-form-item{
                margin-bottom:18px;
            }
            /deep/ .el-input__inner{
                border-radius: 0px;
                height: 36px;
                line-height: 36px;
            }
            /deep/ .el-form-item__label{
                color:#666;
                font-size: 16px;
                font-weight: 400;
            }
            /deep/ .authentication_box_from_item.el-form-item{
                margin-bottom:8px;
                .el-button{
                    width:100%;
                    font-size: 18px;
                    font-weight: 400;
                    background: #1F9EFF;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/authentication/authentication.vue